import _ from 'lodash'
import { Map, Record } from 'immutable'

import { TOGGLE_LINE_BANNER } from './constants'

const LineBannerRecord = new Record({
    show: true,
})

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case TOGGLE_LINE_BANNER: {
            const id = _.get(action, 'data.id', null)

            if (!id) return state

            const currentShow = state.getIn([id, 'show'], true)

            return state.set(id, new LineBannerRecord({ show: !currentShow }))
        }
        default:
            return state
    }
}
